import { Link } from "react-router-dom";
import { Cake, PartyPopper, Heart, Users, Sparkles } from "lucide-react";
import { ChapterLabel, Reveal } from "@/components/landing/Reveal";

const OCCASIONS = [
    {
        icon: Cake,
        title: "Birthday",
        copy: "Make your celebration unforgettable.",
        testId: "occasion-birthday",
    },
    {
        icon: PartyPopper,
        title: "Bachelor / Bachelorette",
        copy: "Turn the last night of freedom into a proper night out.",
        testId: "occasion-bachelor",
    },
    {
        icon: Heart,
        title: "Couple's Night",
        copy: "Upgrade your evening with a premium experience.",
        testId: "occasion-couples",
    },
    {
        icon: Users,
        title: "Group Trip",
        copy: "Arrive with your crew. We handle the table.",
        testId: "occasion-group-trip",
    },
    {
        icon: Sparkles,
        title: "Celebration",
        copy: "Milestone? Promotion? Just because?",
        testId: "occasion-celebration",
    },
];

const Occasions = () => (
    <section
        id="occasions"
        data-testid="occasions-section"
        className="border-y border-white/10 bg-[#0A0A0A]"
    >
        <div className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36">
            <Reveal>
                <ChapterLabel number="Nº 06" title="Occasions" testId="occasions-label" />
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-8 max-w-3xl font-serif text-3xl font-medium leading-tight tracking-tight text-ivory md:text-5xl">
                    MAKE IT A NIGHT{" "}
                    <span className="italic text-gold">TO REMEMBER.</span>
                </h2>
            </Reveal>

            <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {OCCASIONS.map((o, i) => (
                    <Reveal key={o.title} delay={0.05 + i * 0.07} className="h-full">
                        <div
                            data-testid={o.testId}
                            className="group flex h-full flex-col gap-6 rounded-sm border border-white/10 bg-[#0F0F0F] p-8 transition-colors duration-500 hover:border-gold/40"
                        >
                            <o.icon
                                size={24}
                                strokeWidth={1.25}
                                className="text-gold transition-transform duration-500 group-hover:-translate-y-1"
                            />
                            <div>
                                <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-ivory">
                                    {o.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-muted">
                                    {o.copy}
                                </p>
                            </div>
                        </div>
                    </Reveal>
                ))}
                <Reveal delay={0.4} className="h-full">
                    <Link
                        data-testid="occasions-plan-night-btn"
                        to="/plan"
                        aria-label="Plan your night with the Night Builder"
                        className="group flex h-full min-h-[180px] flex-col items-start justify-between gap-6 rounded-sm bg-gold p-8 text-ink transition-colors duration-500 hover:bg-gold-soft"
                    >
                        <span className="text-[10px] font-bold uppercase tracking-[0.3em]">
                            Whatever the reason
                        </span>
                        <span className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em]">
                            Plan My VIP Night
                            <span className="transition-transform duration-300 group-hover:translate-x-1.5">
                                →
                            </span>
                        </span>
                    </Link>
                </Reveal>
            </div>
        </div>
    </section>
);

export default Occasions;
